/* eslint-disable unicorn/prefer-module */
/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
/* eslint-disable import-helpers/order-imports */
/* eslint-disable arrow-body-style */
/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import { Header } from "../Header";
import { useAuthContext } from "../../context/auth";
import { ROLES } from "../../constants/roles";
import { isEdificiosAdmin } from "../../constants/permisos";
import { EdificioForm } from "../EdificioForm";
import { EdificioComisionModal } from "../EdificioComisionModal";
import { getEdificios, updateEdificio, saveEdificio, getCategorias, useCurrency } from "../../utils";
import { TIPOS_ACTIVO } from "../../constants/clasificacionContable";
import { crearActivo, getActivos, eliminarActivo, actualizarActivo } from "../../utils/activos";
import { getProveedores } from "../../utils/proveedores";
import { getLocale } from "../../utils/getLocale";
import { loadExchangeRates } from "../../utils/exchangeRateService";
import { resumenInversionEdificio } from "../../utils/resumenInversionEdificio";

import { EdificiosChartModal } from "./EdificiosChartModal";
import styles from "./EdificiosTable.module.scss";

// Label de display para el tipo de activo: usa el label de clasificacionContable
// (TIPOS_ACTIVO); si no está, capitaliza y reemplaza guiones bajos. Solo display.
const TIPO_ACTIVO_LABELS = Object.fromEntries(TIPOS_ACTIVO.map((t) => [t.value, t.label]));
const getTipoActivoLabel = (value) =>
  TIPO_ACTIVO_LABELS[value] || (value ? value.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "—");

const EdificiosTable = ({ pais: propPais }) => {
  const [categorias, setCategorias] = useState();
  const [edificios, setEdificios] = useState([]);
  const [editingPersonas, setEditingPersonas] = useState(null); // edificio.id en edición inline de personas
  const [editingPersonasValue, setEditingPersonasValue] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  // Estados para filtros
  const [filtroEstado, setFiltroEstado] = useState("");
  const [filtroContrato, setFiltroContrato] = useState("");
  const [busqueda, setBusqueda] = useState("");

  // Estado para ordenamiento genérico: { key, dir } donde dir = "asc" | "desc" | null
  const [sortConfig, setSortConfig] = useState({ key: null, dir: null });

  // Estados para modal de empresas
  const [showModal, setShowModal] = useState(false);
  const [modalEdificio, setModalEdificio] = useState(null);
  const [modalData, setModalData] = useState({
    empresaslistado: "",
    empresasdestacadas: "",
  });

  // Estados para modal de vetos
  const [showVetosModal, setShowVetosModal] = useState(false);
  const [vetosModalEdificio, setVetosModalEdificio] = useState(null);
  const [vetosModalData, setVetosModalData] = useState([]);

  // Estados para modal de contratos
  const [showContratosModal, setShowContratosModal] = useState(false);
  const [showChartModal, setShowChartModal] = useState(false);
  const [contratosModalEdificio, setContratosModalEdificio] = useState(null);
  const [contratosModalData, setContratosModalData] = useState([]);

  // Estados para modal de inversión
  const [showInversionModal, setShowInversionModal] = useState(false);
  const [inversionEdificio, setInversionEdificio] = useState(null);
  const [inversionActivos, setInversionActivos] = useState([]);
  const [inversionProveedores, setInversionProveedores] = useState([]);
  const [inversionLoading, setInversionLoading] = useState(false);
  const [nuevaLinea, setNuevaLinea] = useState(null);
  // Línea guardada en modo edición: { id, tipo_activo, proveedor_id, moneda, costo_unitario, fecha, estado }
  const [editandoLinea, setEditandoLinea] = useState(null);
  const [mostrarDetalle, setMostrarDetalle] = useState(false);

  // Estados para el modal de edición de edificio (puerta única, Bloque C Fase 3a)
  const [showEdificioModal, setShowEdificioModal] = useState(false);
  const [edificioModalData, setEdificioModalData] = useState(null);
  const [edificioModalProveedores, setEdificioModalProveedores] = useState([]);
  const [edificioModalSaving, setEdificioModalSaving] = useState(false);

  // Estados para el modal de comisión de edificio (Bloque C Fase 4)
  const [showComisionModal, setShowComisionModal] = useState(false);
  const [comisionModalEdificio, setComisionModalEdificio] = useState(null);
  const [comisionModalSaving, setComisionModalSaving] = useState(false);

  const { pais, rol, id: usuarioId } = useAuthContext(); // Extraer el rol y el id del contexto
  const { formatAmount } = useCurrency();
  const monedaLocal = pais === "Chile" ? "CLP" : "PEN";
  // Resumen financiero del edificio (en moneda local) sobre los activos ya cargados.
  const resumenInversion = useMemo(() => resumenInversionEdificio(inversionActivos, pais), [inversionActivos, pais]);
  // Monto en inputs: separador de miles en vivo (display, SIN símbolo de moneda) y número
  // limpio al guardar. El símbolo de moneda va en la lista, no en el input.
  const formatMontoInput = (raw) => (raw === "" || raw == null ? "" : Number(raw).toLocaleString(getLocale(pais)));
  const parseMontoInput = (str) => str.replace(/\D/g, "");

  // Gate de la puerta única de edición (Bloque C): solo Ignacio [1,4].
  const puedeEditarTodoEdificio = isEdificiosAdmin(usuarioId);

  // Permisos por rol
  const puedeEditarTodo = rol === ROLES.SUPERADMIN || rol === ROLES.GERENCIA;
  const puedeEditarParcial = rol === ROLES.ADMINISTRATIVO || rol === ROLES.INFRAESTRUCTURA;
  const puedeEditar = puedeEditarTodo || puedeEditarParcial;
  const soloLectura = !puedeEditar;

  const TIPOS_ACTIVO_INVERSION = [
    "pantalla",
    "reproductor",
    "soporte",
    "totem",
    "antena",
    "costo_instalacion",
    "insumos_instalacion",
    "herramientas",
    "otro",
  ];

  const handleOpenInversionModal = async (edificio) => {
    setInversionEdificio(edificio);
    setShowInversionModal(true);
    setInversionLoading(true);
    try {
      // loadExchangeRates: el resumen convierte activos USD/UF/PEN a moneda local (TC histórico);
      // asegurar tasas antes de mostrar para no calcular con 0.
      const [activos, provs] = await Promise.all([
        getActivos(pais, { destino_tipo: "edificio", destino_id: edificio.id }),
        getProveedores(pais),
        loadExchangeRates(),
      ]);
      setInversionActivos(activos);
      setInversionProveedores(provs);
    } catch (err) {
      console.error("Error cargando inversiones:", err);
      toast.error("Error cargando inversiones");
    } finally {
      setInversionLoading(false);
    }
  };

  const handleGuardarLinea = async () => {
    if (!nuevaLinea?.tipo_activo || !nuevaLinea?.costo_unitario) {
      toast.error("Tipo y monto son obligatorios");
      return;
    }
    try {
      const activo = await crearActivo({
        pais,
        fecha_compra: nuevaLinea.fecha_planificada || new Date().toISOString().split("T")[0],
        tipo_activo: nuevaLinea.tipo_activo,
        descripcion: nuevaLinea.descripcion || nuevaLinea.tipo_activo,
        cantidad: 1,
        costo_unitario: Number(nuevaLinea.costo_unitario),
        moneda: nuevaLinea.moneda || "CLP",
        vida_util_meses: 60,
        valor_residual: 0,
        // Estado elegido en el alta. Default 'activo' (Ejecutado): en esta etapa se cargan
        // mayormente gastos ya hechos. Para invertir el default, cambiar el valor inicial del
        // selector en la fila de alta (nuevaLinea.estado).
        estado: nuevaLinea.estado || "activo",
        fecha_planificada: nuevaLinea.fecha_planificada || null,
        destino_tipo: "edificio",
        destino_id: inversionEdificio.id,
        proyecto_nombre: nuevaLinea.proyecto_nombre || null,
        proveedor_id: nuevaLinea.proveedor_id || null,
      });
      setInversionActivos((prev) => [activo, ...prev]);
      setNuevaLinea(null);
      toast.success("Línea agregada");
    } catch (err) {
      console.error("Error al guardar activo:", err, JSON.stringify(err));
      toast.error("Error al guardar: " + (err.message || err));
    }
  };

  const handleEliminarLinea = async (id) => {
    if (!window.confirm("¿Borrar esta línea de inversión?")) return;
    try {
      await eliminarActivo(id);
      setInversionActivos((prev) => prev.filter((a) => a.id !== id));
      toast.success("Línea eliminada");
    } catch {
      toast.error("Error al eliminar");
    }
  };

  // Abre una línea guardada en modo edición con sus valores actuales.
  const handleEditarLinea = (a) => {
    setNuevaLinea(null);
    setEditandoLinea({
      id: a.id,
      tipo_activo: a.tipo_activo || "",
      proveedor_id: a.proveedor_id || null,
      moneda: a.moneda || "CLP",
      costo_unitario: a.costo_unitario != null ? String(a.costo_unitario) : "",
      fecha: a.fecha_planificada || a.fecha_compra || "",
      estado: a.estado || "activo",
    });
  };

  // Guarda la edición de una línea (update parcial de los campos editables).
  // fecha de la línea = fecha_compra; en planificado también alimenta la proyección CapEx.
  const handleGuardarEdicion = async () => {
    const e = editandoLinea;
    if (!e?.tipo_activo || !e?.costo_unitario) {
      toast.error("Tipo y monto son obligatorios");
      return;
    }
    try {
      const cambios = {
        tipo_activo: e.tipo_activo,
        proveedor_id: e.proveedor_id || null,
        moneda: e.moneda || "CLP",
        costo_unitario: Number(e.costo_unitario),
        fecha_compra: e.fecha || null,
        fecha_planificada: e.estado === "planificado" ? e.fecha || null : null,
        estado: e.estado || "activo",
      };
      await actualizarActivo(e.id, cambios);
      setInversionActivos((prev) =>
        prev.map((a) =>
          a.id === e.id
            ? { ...a, ...cambios, proveedor: inversionProveedores.find((p) => p.id === cambios.proveedor_id) || null }
            : a
        )
      );
      setEditandoLinea(null);
      toast.success("Línea actualizada");
    } catch (err) {
      console.error("Error al actualizar línea:", err);
      toast.error("Error al actualizar: " + (err.message || err));
    }
  };

  // Pasa una línea planificada a ejecutada (estado='activo'). NO toca fechas: la
  // depreciación corre desde fecha_compra; fecha_activacion no se usa en este flujo.
  const handleEjecutarLinea = async (id) => {
    try {
      await actualizarActivo(id, { estado: "activo" });
      setInversionActivos((prev) => prev.map((a) => (a.id === id ? { ...a, estado: "activo" } : a)));
      toast.success("Inversión marcada como ejecutada");
    } catch (err) {
      console.error("Error al ejecutar inversión:", err);
      toast.error("Error al ejecutar: " + (err.message || err));
    }
  };

  // Estados únicos para filtro
  const estadosUnicos = useMemo(() => {
    return [...new Set(edificios.map((e) => e.estado))].filter(Boolean);
  }, [edificios]);

  // Función helper para verificar si tiene contrato vigente de un tipo
  const tieneContratoVigente = useCallback((contratos, tipo) => {
    if (!contratos || !Array.isArray(contratos)) return false;
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    return contratos.some((c) => {
      if (c.tipo !== tipo) return false;
      const fechaFin = new Date(c.fechafin + "T23:59:59");
      const fechaInicio = new Date(c.fechainicio + "T00:00:00");
      return hoy >= fechaInicio && hoy <= fechaFin;
    });
  }, []);

  // Función para ciclar ordenamiento: null → asc → desc → null
  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key !== key) return { key, dir: "asc" };
      if (prev.dir === "asc") return { key, dir: "desc" };
      return { key: null, dir: null };
    });
  };

  // Indicador de sort para el header
  const sortIndicator = (key) => {
    if (sortConfig.key !== key) return "";
    return sortConfig.dir === "asc" ? " \u25B2" : " \u25BC";
  };

  // Edificios filtrados
  const edificiosFiltrados = useMemo(() => {
    const filtrados = edificios.filter((edificio) => {
      if (filtroEstado && edificio.estado !== filtroEstado) return false;
      if (busqueda && !edificio.edificio?.toLowerCase().includes(busqueda.toLowerCase())) return false;
      if (filtroContrato && !tieneContratoVigente(edificio.contratos, filtroContrato)) return false;
      return true;
    });

    if (sortConfig.key && sortConfig.dir) {
      filtrados.sort((a, b) => {
        let valA, valB;
        switch (sortConfig.key) {
          case "edificio":
            valA = (a.edificio || "").toLowerCase();
            valB = (b.edificio || "").toLowerCase();
            break;
          case "estado":
            valA = a.estado || "";
            valB = b.estado || "";
            break;
          case "inicio_servicio":
            valA = a.inicio_servicio || "";
            valB = b.inicio_servicio || "";
            break;
          case "personas":
            valA = a.personas || 0;
            valB = b.personas || 0;
            return sortConfig.dir === "asc" ? valA - valB : valB - valA;
          case "estacionamientos":
            valA = a.estacionamientos || 0;
            valB = b.estacionamientos || 0;
            return sortConfig.dir === "asc" ? valA - valB : valB - valA;
          default:
            return 0;
        }
        return sortConfig.dir === "asc" ? valA.localeCompare(valB) : valB.localeCompare(valA);
      });
    }

    return filtrados;
  }, [edificios, filtroEstado, filtroContrato, busqueda, tieneContratoVigente, sortConfig]);

  // Estadísticas para el header - conteo por estado
  const estadisticas = useMemo(() => {
    // Orden fijo de estados
    const ordenEstados = ["OPERATIVO", "INSTALACIÓN", "PROYECTO", "STANDBY", "SIN ESTADO"];

    // Contar edificios por estado (usando edificios sin filtrar para el header)
    const conteoPorEstado = {};
    ordenEstados.forEach((estado) => {
      conteoPorEstado[estado] = 0;
    });

    edificios.forEach((e) => {
      const estado = e.estado && e.estado.trim() !== "" ? e.estado : "SIN ESTADO";
      if (conteoPorEstado[estado] !== undefined) {
        conteoPorEstado[estado]++;
      } else {
        // Estado no previsto, agregar a "SIN ESTADO"
        conteoPorEstado["SIN ESTADO"]++;
      }
    });

    return {
      estados: ordenEstados.map((estado) => ({
        nombre: estado,
        cantidad: conteoPorEstado[estado],
      })),
      totalEdificios: edificios.length,
    };
  }, [edificios]);

  // Formatear fecha como "MAY 25" (mes abreviado + año corto)
  const formatMesAnio = (fechaStr) => {
    if (!fechaStr) return "-";
    const date = new Date(fechaStr + "T12:00:00");
    const mes = date.toLocaleDateString("es", { month: "short" }).toUpperCase().replace(".", "");
    const anio = date.toLocaleDateString("es", { year: "2-digit" });
    return `${mes} ${anio}`;
  };

  // Formatear fecha corta
  const formatFecha = (fechaStr) => {
    if (!fechaStr) return "-";
    return new Date(fechaStr + "T12:00:00").toLocaleDateString("es", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });
  };

  // Formatear porcentaje con 1 decimal según país
  const formatPorcentaje = useCallback(
    (valor) => {
      if (!valor && valor !== 0) return "-";
      const numero = typeof valor === "string" ? parseFloat(valor) : valor;
      return numero.toLocaleString(getLocale(pais), {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
    },
    [pais]
  );

  // Calcular estado de contrato: VIGENTE, POR VENCER (menos de 60 días), VENCIDO
  const getContratoStatus = (contratos, tipo) => {
    if (!contratos || !Array.isArray(contratos)) return null;
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    // Filtrar contratos del tipo especificado y ordenar por fechafin descendente
    const contratosDelTipo = contratos
      .filter((c) => c.tipo === tipo)
      .sort((a, b) => new Date(b.fechafin) - new Date(a.fechafin));

    if (contratosDelTipo.length === 0) return null;

    // Tomar el contrato más reciente
    const contrato = contratosDelTipo[0];
    const fechaFin = new Date(contrato.fechafin + "T23:59:59");
    const fechaInicio = new Date(contrato.fechainicio + "T00:00:00");

    // Si aún no empezó
    if (hoy < fechaInicio) return { status: "PENDIENTE", color: "#6c757d" };

    // Si ya terminó
    if (hoy > fechaFin) return { status: "VENCIDO", color: "#dc3545" };

    // Calcular días restantes
    const diasRestantes = Math.ceil((fechaFin - hoy) / (1000 * 60 * 60 * 24));

    if (diasRestantes <= 60) {
      return { status: "POR VENCER", color: "#b8860b" }; // Amarillo oscuro (DarkGoldenrod)
    }

    return { status: "VIGENTE", color: "#28a745" };
  };

  // Función reutilizable para obtener edificios y ordenarlos
  const fetchEdificios = async () => {
    try {
      const data = await getEdificios({ pais: propPais || pais });

      // Ordenar los edificios primero por estado y luego por cantidad de personas
      const sortedData = data.sort((a, b) => {
        const estadosOrder = { OPERATIVO: 1, INSTALACIÓN: 2, PROYECTO: 3, STANDBY: 4 };
        // Obtener el orden del estado, si no existe o está vacío, asignar 5 (último)
        const ordenA = a.estado && a.estado.trim() !== "" ? estadosOrder[a.estado] || 5 : 5;
        const ordenB = b.estado && b.estado.trim() !== "" ? estadosOrder[b.estado] || 5 : 5;

        if (ordenA !== ordenB) {
          return ordenA - ordenB;
        }
        return (b.personas || 0) - (a.personas || 0);
      });

      setEdificios(sortedData);
    } catch (err) {
      setError(err.message);
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Inicializa categorías y edificios
  useEffect(() => {
    const initialize = async () => {
      const newCategorias = await getCategorias();
      setCategorias(newCategorias);
    };

    initialize();
  }, [pais]);

  // Usa fetchEdificios para cargar datos iniciales
  useEffect(() => {
    fetchEdificios();
  }, [propPais, pais]);

  // Edición inline de PERSONAS (click-to-edit)
  const handlePersonasClick = (edificio) => {
    if (!puedeEditar) return;
    setEditingPersonas(edificio.id);
    setEditingPersonasValue(edificio.personas?.toString() || "");
  };

  const handlePersonasSave = async (edificioId) => {
    const trimmed = editingPersonasValue.trim();
    const newValue = trimmed === "" ? null : parseInt(trimmed.replace(/\D/g, ""), 10);
    if (newValue !== null && Number.isNaN(newValue)) {
      setEditingPersonas(null);
      return;
    }
    const edificio = edificios.find((e) => e.id === edificioId);
    if (!edificio) {
      setEditingPersonas(null);
      return;
    }
    try {
      // Pasar campos existentes para no pisarlos: updateEdificio hace PATCH y
      // empresaslistado/empresasdestacadas caen a null si no se envían.
      await updateEdificio({
        id: edificioId,
        personas: newValue,
        estacionamientos: edificio.estacionamientos,
        vetos: edificio.vetos || "",
        empresaslistado: edificio.empresaslistado || "",
        empresasdestacadas: edificio.empresasdestacadas || "",
      });
      setEdificios((prev) => prev.map((e) => (e.id === edificioId ? { ...e, personas: newValue } : e)));
    } catch (err) {
      console.error("Error actualizando personas:", err);
      toast.error("Error actualizando personas");
    }
    setEditingPersonas(null);
  };

  const handlePersonasCancel = () => {
    setEditingPersonas(null);
  };

  // Obtener lista de empresas como array (debe estar antes de early returns)
  const empresasArray = useMemo(() => {
    if (!modalData.empresaslistado) return [];
    return modalData.empresaslistado
      .split(",")
      .map((e) => e.trim())
      .filter((e) => e.length > 0);
  }, [modalData.empresaslistado]);

  // Obtener empresas destacadas como array
  const destacadasArray = useMemo(() => {
    if (!modalData.empresasdestacadas) return [];
    return modalData.empresasdestacadas
      .split(",")
      .map((e) => e.trim())
      .filter((e) => e.length > 0);
  }, [modalData.empresasdestacadas]);

  // Categorías ordenadas alfabéticamente (debe estar antes de early returns)
  const categoriasOrdenadas = useMemo(() => {
    if (!categorias) return [];
    return [...categorias].sort((a, b) => a.nombre.localeCompare(b.nombre));
  }, [categorias]);

  // Funciones para modal de empresas
  const handleOpenEmpresasModal = (edificio) => {
    setModalEdificio(edificio);
    setModalData({
      empresaslistado: edificio.empresaslistado || "",
      empresasdestacadas: edificio.empresasdestacadas || "",
    });
    setShowModal(true);
  };

  // Toggle empresa destacada
  const handleToggleDestacada = (empresa) => {
    const isDestacada = destacadasArray.includes(empresa);
    if (isDestacada) {
      // Remover de destacadas
      const newDestacadas = destacadasArray.filter((e) => e !== empresa);
      setModalData((prev) => ({
        ...prev,
        empresasdestacadas: newDestacadas.join(", "),
      }));
    } else {
      // Agregar a destacadas (máximo 5)
      if (destacadasArray.length >= 5) {
        toast.error("Máximo 5 empresas destacadas");
        return;
      }
      setModalData((prev) => ({
        ...prev,
        empresasdestacadas: [...destacadasArray, empresa].join(", "),
      }));
    }
  };

  const handleSaveEmpresasModal = async () => {
    try {
      setLoading(true);
      const updatedData = {
        id: modalEdificio.id,
        personas: modalEdificio.personas,
        estacionamientos: modalEdificio.estacionamientos,
        vetos: modalEdificio.vetos || "",
        empresaslistado: modalData.empresaslistado,
        empresasdestacadas: modalData.empresasdestacadas,
      };
      await updateEdificio(updatedData);
      setShowModal(false);
      toast.success("Empresas actualizadas exitosamente");
      await fetchEdificios();
    } catch (error) {
      console.error("Error al actualizar empresas:", error);
      toast.error("Error al actualizar empresas");
    } finally {
      setLoading(false);
    }
  };

  // Funciones para modal de vetos
  const handleOpenVetosModal = (edificio) => {
    const vetosArray = edificio.vetos ? edificio.vetos.split(",").map((v) => v.trim()) : [];
    setVetosModalEdificio(edificio);
    setVetosModalData(vetosArray);
    setShowVetosModal(true);
  };

  const handleVetosModalChange = (categoriaId) => {
    setVetosModalData((prev) => {
      if (prev.includes(categoriaId)) {
        return prev.filter((id) => id !== categoriaId);
      }
      return [...prev, categoriaId];
    });
  };

  const handleSaveVetosModal = async () => {
    try {
      setLoading(true);
      const formattedVetos = vetosModalData.join(", ");
      const updatedData = {
        id: vetosModalEdificio.id,
        personas: vetosModalEdificio.personas,
        estacionamientos: vetosModalEdificio.estacionamientos,
        vetos: formattedVetos,
        empresaslistado: vetosModalEdificio.empresaslistado || "",
        empresasdestacadas: vetosModalEdificio.empresasdestacadas || "",
      };
      await updateEdificio(updatedData);
      setShowVetosModal(false);
      toast.success("Vetos actualizados exitosamente");
      await fetchEdificios();
    } catch (error) {
      console.error("Error al actualizar vetos:", error);
      toast.error("Error al actualizar vetos");
    } finally {
      setLoading(false);
    }
  };

  // Funciones para modal de contratos
  const handleOpenContratosModal = (edificio) => {
    setContratosModalEdificio(edificio);
    // Parsear contratos existentes o inicializar array vacío
    const contratosExistentes = edificio.contratos || [];
    setContratosModalData(Array.isArray(contratosExistentes) ? contratosExistentes : []);
    setShowContratosModal(true);
  };

  const handleAddContrato = (tipo) => {
    setContratosModalData((prev) => [...prev, { tipo, fechainicio: "", fechafin: "" }]);
  };

  const handleRemoveContrato = (index) => {
    setContratosModalData((prev) => prev.filter((_, i) => i !== index));
  };

  const handleContratoChange = (index, field, value) => {
    setContratosModalData((prev) =>
      prev.map((contrato, i) => (i === index ? { ...contrato, [field]: value } : contrato))
    );
  };

  const handleSaveContratosModal = async () => {
    try {
      setLoading(true);
      // Filtrar contratos incompletos (sin fechas)
      const contratosValidos = contratosModalData.filter((c) => c.fechainicio && c.fechafin);
      const updatedData = {
        id: contratosModalEdificio.id,
        personas: contratosModalEdificio.personas,
        estacionamientos: contratosModalEdificio.estacionamientos,
        vetos: contratosModalEdificio.vetos || "",
        empresaslistado: contratosModalEdificio.empresaslistado || "",
        empresasdestacadas: contratosModalEdificio.empresasdestacadas || "",
        contratos: contratosValidos,
      };
      await updateEdificio(updatedData);
      setShowContratosModal(false);
      toast.success("Contratos actualizados exitosamente");
      await fetchEdificios();
    } catch (error) {
      console.error("Error al actualizar contratos:", error);
      toast.error("Error al actualizar contratos");
    } finally {
      setLoading(false);
    }
  };

  // ── Modal de edición de edificio (puerta única, Bloque C Fase 3a) ──
  const handleOpenEdificioModal = async (edificio) => {
    setEdificioModalData(edificio);
    setShowEdificioModal(true);
    try {
      const provs = await getProveedores(pais);
      setEdificioModalProveedores(provs);
    } catch (err) {
      console.error("Error cargando proveedores:", err);
      setEdificioModalProveedores([]);
    }
  };

  const handleSaveEdificioModal = async (objEntero) => {
    setEdificioModalSaving(true);
    // EdificioForm en modo crear parte de edificio=null → el objeto no trae `id`.
    const esEdicion = !!objEntero.id;
    try {
      if (esEdicion) {
        // objEntero ya trae el edificio completo (regla 10.54): comisión re-pasada intacta.
        await updateEdificio(objEntero);
      } else {
        // Crear: normalizar "" → null (columnas numéricas/date) e inyectar país, igual que
        // CargarEdificio (Fase 3b). Nace SIN comisión: las columnas comision_* nullable no se setean.
        const limpio = Object.fromEntries(Object.entries(objEntero).map(([k, v]) => [k, v === "" ? null : v]));
        await saveEdificio({ ...limpio, pais });
      }
      await fetchEdificios();
      setShowEdificioModal(false);
      setEdificioModalData(null);
      toast.success(esEdicion ? "Edificio actualizado exitosamente" : "Edificio creado exitosamente");
    } catch (error) {
      console.error("Error al guardar edificio:", error);
      toast.error(esEdicion ? "Error al actualizar el edificio" : "Error al crear el edificio");
    } finally {
      setEdificioModalSaving(false);
    }
  };

  // ── Modal de comisión de edificio (Bloque C Fase 4) ──
  const handleOpenComisionModal = (edificio) => {
    setComisionModalEdificio(edificio);
    setShowComisionModal(true);
  };

  const handleSaveComisionModal = async (objEntero) => {
    setComisionModalSaving(true);
    try {
      // objEntero trae el edificio completo con las 13 columnas de comisión actualizadas (regla 10.54).
      await updateEdificio(objEntero);
      await fetchEdificios();
      setShowComisionModal(false);
      setComisionModalEdificio(null);
      toast.success("Comisión actualizada exitosamente");
    } catch (error) {
      console.error("Error al actualizar comisión:", error);
      toast.error("Error al actualizar la comisión");
    } finally {
      setComisionModalSaving(false);
    }
  };

  // Badge de estado del ciclo de vida del edificio (Fase 1)
  const renderEstadoBadge = (estado) => {
    const map = {
      PROSPECTO: styles.estadoProspecto,
      PROYECTO: styles.estadoProyecto,
      PILOTO: styles.estadoPiloto,
      INSTALACIÓN: styles.estadoInstalacion,
      OPERATIVO: styles.estadoOperativo,
      CADUCADO: styles.estadoCaducado,
    };
    const cls = map[estado] || "";
    return <span className={`${styles.estadoBadge} ${cls}`}>{estado || "—"}</span>;
  };

  // Early returns
  if (loading) return <div>Cargando edificios...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className={styles.pageContainer}>
      <Header
        leftContent={
          <div className={styles.statsGrid}>
            {estadisticas.estados.map((item) => (
              <div key={item.nombre} className={styles.statItem}>
                <span className={styles.statLabel}>{item.nombre}:</span>
                <strong className={styles.statValue}>{item.cantidad}</strong>
              </div>
            ))}
          </div>
        }
      >
        <div className={styles.filterRow}>
          <div className={styles.filterItem}>
            <select
              className={styles.filterSelect}
              value={filtroEstado}
              onChange={(e) => setFiltroEstado(e.target.value)}
            >
              <option value="">Todos los estados</option>
              {estadosUnicos.map((estado, i) => (
                <option key={i} value={estado}>
                  {estado}
                </option>
              ))}
            </select>
          </div>
          <div className={styles.filterItem}>
            <select
              className={`${styles.filterSelect} ${filtroContrato ? styles.activeFilter : ""}`}
              value={filtroContrato}
              onChange={(e) => setFiltroContrato(e.target.value)}
            >
              <option value="">Todos los contratos</option>
              <option value="INVENTARIO">INVENTARIO vigente</option>
              <option value="CARTELERÍA">CARTELERÍA vigente</option>
            </select>
          </div>
          <div className={styles.filterItem}>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Buscar edificio..."
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
              style={{ height: "2.5rem", borderRadius: "8px" }}
            />
          </div>
          <button className="chart-btn" onClick={() => setShowChartModal(true)} title="Ver gráfico de crecimiento">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
            </svg>
            Gráfico
          </button>
          {puedeEditarTodoEdificio && (
            <button className="btn btn-sm btn-primary" onClick={() => handleOpenEdificioModal(null)}>
              + Edificio
            </button>
          )}
        </div>
      </Header>

      <div className={styles.contentWrapper}>
        <table className={`table table-bordered table-striped table-hover small text-sm ${styles.edificiosTable}`}>
          <thead>
            <tr className="table-dark text-center">
              <th
                rowSpan={3}
                className={`${styles.colEstado} ${styles.sortableHeader}`}
                onClick={() => handleSort("estado")}
              >
                ESTADO{sortIndicator("estado")}
              </th>
              <th
                rowSpan={3}
                className={`${styles.colNombre} ${styles.sortableHeader}`}
                onClick={() => handleSort("edificio")}
              >
                NOMBRE{sortIndicator("edificio")}
              </th>
              <th rowSpan={3} className={styles.colUbicacion}>
                UBICACIÓN
              </th>
              <th rowSpan={3} className={styles.colPersonas}>
                PERSONAS
              </th>
              <th colSpan={6} className={styles.colPantallasGrupo}>
                PANTALLAS
              </th>
              <th rowSpan={3} className={styles.colContrato}>
                CONTRATO
              </th>
              <th rowSpan={3} className={styles.colAcciones}>
                ACCIONES
              </th>
            </tr>
            <tr className="table-dark text-center">
              <th colSpan={4} className={styles.colSubGrupoInv}>
                INV. PUBLICITARIO
              </th>
              <th colSpan={2} className={styles.colSubGrupoCart}>
                CARTELERÍA
              </th>
            </tr>
            <tr className="table-dark text-center">
              <th className={styles.colAsc}>ASC</th>
              <th className={styles.colCir}>CIR</th>
              <th className={styles.colEsp}>ESP</th>
              <th className={styles.colCow}>COW</th>
              <th className={styles.colDir}>DIR</th>
              <th className={styles.colOtr}>OTR</th>
            </tr>
          </thead>
          <tbody>
            {edificiosFiltrados.map((edificio) => (
              <tr key={edificio.id}>
                <td className={styles.colEstado}>{renderEstadoBadge(edificio.estado)}</td>
                <td className={styles.colNombre} style={{ textAlign: "left" }}>
                  {edificio.edificio ? edificio.edificio.toUpperCase() : "—"}
                </td>
                <td className={styles.colUbicacion}>
                  {edificio.direccion ? `${edificio.direccion}, ${edificio.ubicacion}` : edificio.ubicacion || "—"}
                </td>
                <td className="text-center" style={{ cursor: puedeEditar ? "pointer" : "default" }}>
                  {editingPersonas === edificio.id ? (
                    <input
                      type="text"
                      value={editingPersonasValue}
                      onChange={(e) => setEditingPersonasValue(e.target.value)}
                      onBlur={() => handlePersonasSave(edificio.id)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handlePersonasSave(edificio.id);
                        if (e.key === "Escape") handlePersonasCancel();
                      }}
                      autoFocus
                      style={{
                        width: "100%",
                        textAlign: "center",
                        border: "1px solid #0d6efd",
                        borderRadius: "3px",
                        padding: "2px 4px",
                        fontSize: "inherit",
                        backgroundColor: "#fff",
                      }}
                    />
                  ) : (
                    <span onClick={() => handlePersonasClick(edificio)}>
                      {edificio.personas ? Number(edificio.personas).toLocaleString(getLocale(pais)) : "—"}
                    </span>
                  )}
                </td>
                <td className={styles.colAsc}>{edificio.pantallas || "—"}</td>
                <td className={styles.colCir}>{edificio.totems || "—"}</td>
                <td className={styles.colEsp}>{edificio.espera || "—"}</td>
                <td className={styles.colCow}>{edificio.cowork || "—"}</td>
                <td className={styles.colDir}>—</td>
                <td className={styles.colOtr}>—</td>
                <td className={styles.colContrato}>
                  {(() => {
                    const statusInv = getContratoStatus(edificio.contratos, "INVENTARIO");
                    const statusCart = getContratoStatus(edificio.contratos, "CARTELERÍA");
                    if (!statusInv && !statusCart) {
                      return <span style={{ color: "#999" }}>—</span>;
                    }
                    return (
                      <>
                        {statusInv && (
                          <div style={{ color: statusInv.color, fontWeight: "bold", fontSize: "0.7rem" }}>
                            PUB: {statusInv.status}
                          </div>
                        )}
                        {statusCart && (
                          <div style={{ color: statusCart.color, fontWeight: "bold", fontSize: "0.7rem" }}>
                            CART: {statusCart.status}
                          </div>
                        )}
                      </>
                    );
                  })()}
                </td>
                <td className={styles.colAcciones} onClick={(e) => e.stopPropagation()}>
                  <div className="d-flex flex-nowrap gap-1 justify-content-center">
                    <button
                      className={`btn btn-sm btn-secondary ${styles.actionBtn}`}
                      onClick={() => handleOpenEmpresasModal(edificio)}
                    >
                      Empresas
                    </button>
                    <button
                      className={`btn btn-sm btn-warning ${styles.actionBtn}`}
                      onClick={() => handleOpenVetosModal(edificio)}
                    >
                      Vetos
                    </button>
                    {puedeEditarTodo && (
                      <button
                        className={`btn btn-sm btn-info ${styles.actionBtn}`}
                        onClick={() => handleOpenContratosModal(edificio)}
                      >
                        Cartelería
                      </button>
                    )}
                    {puedeEditarTodo && (
                      <button
                        className={`btn btn-sm btn-primary ${styles.actionBtn}`}
                        onClick={() => handleOpenInversionModal(edificio)}
                      >
                        Inversión
                      </button>
                    )}
                    {puedeEditarTodoEdificio && (
                      <button
                        className={`btn btn-sm btn-dark ${styles.actionBtn}`}
                        onClick={() => handleOpenComisionModal(edificio)}
                      >
                        Comisiones
                      </button>
                    )}
                    {puedeEditarTodoEdificio && (
                      <button
                        className={`btn btn-sm btn-success ${styles.actionBtn}`}
                        onClick={() => handleOpenEdificioModal(edificio)}
                      >
                        Editar
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal para editar Empresas - 2 columnas */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Empresas - {modalEdificio?.edificio?.toUpperCase()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>
                <strong>Lista de Empresas</strong> (separadas por coma)
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={6}
                value={modalData.empresaslistado}
                onChange={(e) => setModalData({ ...modalData, empresaslistado: e.target.value })}
                style={{ textTransform: "uppercase" }}
                placeholder="EMPRESA1, EMPRESA2, EMPRESA3..."
              />
            </Form.Group>

            <div style={{ display: "flex", gap: "20px" }}>
              {/* Columna izquierda - Todas las empresas con checkboxes */}
              <div style={{ flex: 1 }}>
                <Form.Label>
                  <strong>Seleccionar Destacadas</strong>
                  <span style={{ color: "#666", fontSize: "12px", marginLeft: "8px" }}>(marcar hasta 5)</span>
                </Form.Label>
                <div
                  style={{
                    maxHeight: "350px",
                    overflowY: "auto",
                    border: "1px solid #ccc",
                    padding: "10px",
                    borderRadius: "4px",
                    backgroundColor: "#f8f9fa",
                  }}
                >
                  {empresasArray.length > 0 ? (
                    empresasArray.map((empresa, idx) => (
                      <Form.Check
                        key={idx}
                        type="checkbox"
                        id={`empresa-${idx}`}
                        label={empresa.toUpperCase()}
                        checked={destacadasArray.includes(empresa)}
                        onChange={() => handleToggleDestacada(empresa)}
                        style={{ marginBottom: "4px" }}
                      />
                    ))
                  ) : (
                    <span style={{ color: "#999" }}>Ingrese empresas arriba</span>
                  )}
                </div>
              </div>

              {/* Columna derecha - Empresas destacadas */}
              <div style={{ flex: 1 }}>
                <Form.Label>
                  <strong>Empresas Destacadas</strong>
                  <span
                    style={{ color: destacadasArray.length >= 5 ? "red" : "#666", fontSize: "12px", marginLeft: "8px" }}
                  >
                    ({destacadasArray.length}/5)
                  </span>
                </Form.Label>
                <div
                  style={{
                    minHeight: "350px",
                    border: "1px solid #28a745",
                    padding: "10px",
                    borderRadius: "4px",
                    backgroundColor: "#e8f5e9",
                  }}
                >
                  {destacadasArray.length > 0 ? (
                    destacadasArray.map((empresa, idx) => (
                      <div
                        key={idx}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "6px 8px",
                          backgroundColor: "white",
                          borderRadius: "4px",
                          marginBottom: "4px",
                          border: "1px solid #28a745",
                        }}
                      >
                        <span style={{ fontWeight: "bold" }}>{empresa.toUpperCase()}</span>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          style={{ fontSize: "10px", padding: "2px 6px" }}
                          onClick={() => handleToggleDestacada(empresa)}
                        >
                          ×
                        </button>
                      </div>
                    ))
                  ) : (
                    <span style={{ color: "#999" }}>Ninguna empresa destacada</span>
                  )}
                </div>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSaveEmpresasModal}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para editar Vetos - Categorías ordenadas alfabéticamente */}
      <Modal show={showVetosModal} onHide={() => setShowVetosModal(false)} dialogClassName="modal-90w">
        <Modal.Header closeButton>
          <Modal.Title>Vetos - {vetosModalEdificio?.edificio?.toUpperCase()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ color: "#666", marginBottom: "15px" }}>
            Seleccione las categorías que desea vetar para este edificio:
          </p>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: "4px 10px",
              maxHeight: "600px",
              overflowY: "auto",
              padding: "15px 25px",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          >
            {categoriasOrdenadas.map((categoria) => {
              const isSelected = vetosModalData.includes(categoria.id.toString());
              return (
                <Form.Check
                  key={categoria.id}
                  type="checkbox"
                  id={`veto-modal-${categoria.id}`}
                  label={
                    <span
                      style={{
                        backgroundColor: isSelected ? "#ffebee" : "transparent",
                        color: isSelected ? "#c62828" : "inherit",
                        padding: "1px 4px",
                        borderRadius: "3px",
                        fontWeight: isSelected ? 500 : 400,
                      }}
                    >
                      {categoria.nombre}
                    </span>
                  }
                  checked={isSelected}
                  onChange={() => handleVetosModalChange(categoria.id.toString())}
                  style={{
                    fontSize: "12px",
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    margin: 0,
                  }}
                />
              );
            })}
          </div>
          <div style={{ marginTop: "10px", color: "#666" }}>
            <strong>Vetos seleccionados:</strong> {vetosModalData.length}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowVetosModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSaveVetosModal}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para editar Contratos */}
      <Modal show={showContratosModal} onHide={() => setShowContratosModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Contratos - {contratosModalEdificio?.edificio?.toUpperCase()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ display: "flex", gap: "30px" }}>
            {/* Sección INVENTARIO */}
            <div style={{ flex: 1 }}>
              <div
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}
              >
                <strong style={{ color: "#0d6efd" }}>INVENTARIO PUBLICITARIO</strong>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => handleAddContrato("INVENTARIO")}
                  style={{ fontSize: "11px" }}
                >
                  + Agregar
                </Button>
              </div>
              <div style={{ border: "1px solid #0d6efd", borderRadius: "4px", padding: "10px", minHeight: "200px" }}>
                {contratosModalData
                  .map((contrato, index) => ({ ...contrato, originalIndex: index }))
                  .filter((c) => c.tipo === "INVENTARIO")
                  .map((contrato) => (
                    <div
                      key={contrato.originalIndex}
                      style={{
                        backgroundColor: "#f8f9fa",
                        padding: "10px",
                        borderRadius: "4px",
                        marginBottom: "8px",
                        border: "1px solid #dee2e6",
                      }}
                    >
                      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <Form.Group style={{ flex: 1 }}>
                          <Form.Label style={{ fontSize: "11px", marginBottom: "2px" }}>Inicio</Form.Label>
                          <Form.Control
                            type="date"
                            size="sm"
                            value={contrato.fechainicio}
                            onChange={(e) =>
                              handleContratoChange(contrato.originalIndex, "fechainicio", e.target.value)
                            }
                          />
                        </Form.Group>
                        <Form.Group style={{ flex: 1 }}>
                          <Form.Label style={{ fontSize: "11px", marginBottom: "2px" }}>Fin</Form.Label>
                          <Form.Control
                            type="date"
                            size="sm"
                            value={contrato.fechafin}
                            onChange={(e) => handleContratoChange(contrato.originalIndex, "fechafin", e.target.value)}
                          />
                        </Form.Group>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => handleRemoveContrato(contrato.originalIndex)}
                          style={{ fontSize: "10px", padding: "4px 8px", marginTop: "18px" }}
                        >
                          ×
                        </Button>
                      </div>
                    </div>
                  ))}
                {contratosModalData.filter((c) => c.tipo === "INVENTARIO").length === 0 && (
                  <span style={{ color: "#999", fontSize: "12px" }}>Sin contratos de inventario</span>
                )}
              </div>
            </div>

            {/* Sección CARTELERÍA */}
            <div style={{ flex: 1 }}>
              <div
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}
              >
                <strong style={{ color: "#198754" }}>CARTELERÍA DIGITAL</strong>
                <Button
                  variant="outline-success"
                  size="sm"
                  onClick={() => handleAddContrato("CARTELERÍA")}
                  style={{ fontSize: "11px" }}
                >
                  + Agregar
                </Button>
              </div>
              <div style={{ border: "1px solid #198754", borderRadius: "4px", padding: "10px", minHeight: "200px" }}>
                {contratosModalData
                  .map((contrato, index) => ({ ...contrato, originalIndex: index }))
                  .filter((c) => c.tipo === "CARTELERÍA")
                  .map((contrato) => (
                    <div
                      key={contrato.originalIndex}
                      style={{
                        backgroundColor: "#f8f9fa",
                        padding: "10px",
                        borderRadius: "4px",
                        marginBottom: "8px",
                        border: "1px solid #dee2e6",
                      }}
                    >
                      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        <Form.Group style={{ flex: 1 }}>
                          <Form.Label style={{ fontSize: "11px", marginBottom: "2px" }}>Inicio</Form.Label>
                          <Form.Control
                            type="date"
                            size="sm"
                            value={contrato.fechainicio}
                            onChange={(e) =>
                              handleContratoChange(contrato.originalIndex, "fechainicio", e.target.value)
                            }
                          />
                        </Form.Group>
                        <Form.Group style={{ flex: 1 }}>
                          <Form.Label style={{ fontSize: "11px", marginBottom: "2px" }}>Fin</Form.Label>
                          <Form.Control
                            type="date"
                            size="sm"
                            value={contrato.fechafin}
                            onChange={(e) => handleContratoChange(contrato.originalIndex, "fechafin", e.target.value)}
                          />
                        </Form.Group>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => handleRemoveContrato(contrato.originalIndex)}
                          style={{ fontSize: "10px", padding: "4px 8px", marginTop: "18px" }}
                        >
                          ×
                        </Button>
                      </div>
                    </div>
                  ))}
                {contratosModalData.filter((c) => c.tipo === "CARTELERÍA").length === 0 && (
                  <span style={{ color: "#999", fontSize: "12px" }}>Sin contratos de cartelería</span>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowContratosModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSaveContratosModal}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal Inversión */}
      <Modal
        show={showInversionModal}
        onHide={() => {
          setShowInversionModal(false);
          setNuevaLinea(null);
          setEditandoLinea(null);
          setMostrarDetalle(false);
        }}
        dialogClassName="modal-90w"
      >
        <Modal.Header closeButton>
          <Modal.Title>Inversión — {inversionEdificio?.edificio?.toUpperCase()}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ display: "flex", flexDirection: "column", maxHeight: "70vh", overflow: "hidden" }}>
          {inversionLoading ? (
            <div style={{ textAlign: "center", padding: 40 }}>Cargando...</div>
          ) : (
            <>
              {/* Zona FIJA: resumen + desglose (no scrollea) */}
              <div style={{ flexShrink: 0 }}>
                {inversionActivos.length > 0 && (
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 12, marginBottom: 16 }}>
                    <div
                      style={{
                        flex: "2 1 220px",
                        background: "#e7f1ff",
                        border: "1px solid #b6d4fe",
                        borderRadius: 8,
                        padding: "12px 16px",
                      }}
                    >
                      <div
                        style={{ fontSize: "0.7rem", color: "#084298", textTransform: "uppercase", letterSpacing: 0.5 }}
                      >
                        Inversión ejecutada
                      </div>
                      <div style={{ fontSize: "1.6rem", fontWeight: 700, color: "#084298" }}>
                        {formatAmount(resumenInversion.inversionEjecutada, monedaLocal)}
                      </div>
                      {resumenInversion.inversionPlanificada > 0 && (
                        <div style={{ fontSize: "0.75rem", color: "#856404", marginTop: 2 }}>
                          + {formatAmount(resumenInversion.inversionPlanificada, monedaLocal)} planificado
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        flex: "1 1 150px",
                        background: "#f8f9fa",
                        border: "1px solid #dee2e6",
                        borderRadius: 8,
                        padding: "12px 16px",
                      }}
                    >
                      <div style={{ fontSize: "0.7rem", color: "#6c757d", textTransform: "uppercase" }}>
                        Valor libro hoy
                      </div>
                      <div style={{ fontSize: "1.15rem", fontWeight: 600 }}>
                        {formatAmount(resumenInversion.valorLibroHoy, monedaLocal)}
                      </div>
                    </div>
                    <div
                      style={{
                        flex: "1 1 150px",
                        background: "#f8f9fa",
                        border: "1px solid #dee2e6",
                        borderRadius: 8,
                        padding: "12px 16px",
                      }}
                    >
                      <div style={{ fontSize: "0.7rem", color: "#6c757d", textTransform: "uppercase" }}>
                        Depreciación acumulada
                      </div>
                      <div style={{ fontSize: "1.15rem", fontWeight: 600 }}>
                        {formatAmount(resumenInversion.depreciacionAcumulada, monedaLocal)}
                      </div>
                    </div>
                    <div
                      style={{
                        flex: "1 1 150px",
                        background: "#f8f9fa",
                        border: "1px solid #dee2e6",
                        borderRadius: 8,
                        padding: "12px 16px",
                      }}
                    >
                      <div style={{ fontSize: "0.7rem", color: "#6c757d", textTransform: "uppercase" }}>
                        Depreciación mensual
                      </div>
                      <div style={{ fontSize: "1.15rem", fontWeight: 600 }}>
                        {formatAmount(resumenInversion.depreciacionMensual, monedaLocal)}
                        <span style={{ fontSize: "0.7rem", fontWeight: 400, color: "#6c757d" }}> /mes</span>
                      </div>
                    </div>
                  </div>
                )}
                {inversionActivos.length > 0 && resumenInversion.porTipo.length > 0 && (
                  <div style={{ marginBottom: 16 }}>
                    <div style={{ fontSize: "0.75rem", color: "#6c757d", textTransform: "uppercase", marginBottom: 4 }}>
                      Desglose por tipo
                    </div>
                    <table className="table table-sm" style={{ fontSize: "0.8rem", maxWidth: 520 }}>
                      <thead className="table-light">
                        <tr>
                          <th>Tipo</th>
                          <th style={{ textAlign: "right" }}>Inversión</th>
                          <th style={{ textAlign: "right" }}>Valor libro</th>
                        </tr>
                      </thead>
                      <tbody>
                        {resumenInversion.porTipo.map((t) => (
                          <tr key={t.tipo_activo}>
                            <td>{getTipoActivoLabel(t.tipo_activo)}</td>
                            <td style={{ textAlign: "right" }}>{formatAmount(t.inversionEjecutada, monedaLocal)}</td>
                            <td style={{ textAlign: "right" }}>{formatAmount(t.valorLibroHoy, monedaLocal)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              {/* Toggle del detalle (fijo): expande la lista de líneas + alta */}
              <div style={{ flexShrink: 0, display: "flex", gap: 12, alignItems: "center", marginBottom: 8 }}>
                <button
                  className="btn btn-link btn-sm"
                  style={{ padding: 0, textDecoration: "none" }}
                  onClick={() => setMostrarDetalle((v) => !v)}
                >
                  {mostrarDetalle ? "▾" : "▸"} Ver detalle de activos ({inversionActivos.length})
                </button>
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => {
                    setMostrarDetalle(true);
                    setNuevaLinea({
                      tipo_activo: "",
                      descripcion: "",
                      moneda: "CLP",
                      costo_unitario: "",
                      fecha_planificada: "",
                      proyecto_nombre: "",
                      proveedor_id: null,
                    });
                  }}
                  disabled={!!nuevaLinea || !!editandoLinea}
                >
                  + Agregar línea
                </button>
              </div>
              {/* Zona DETALLE (desplegable): scrollea interno, toma el alto restante */}
              {mostrarDetalle && (
                <div style={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
                  <table className="table table-sm table-bordered" style={{ fontSize: "0.82rem" }}>
                    <thead className="table-dark">
                      <tr>
                        <th style={{ width: "15%" }}>Tipo</th>
                        <th style={{ width: "28%" }}>Proveedor</th>
                        <th style={{ width: "10%" }}>Moneda</th>
                        <th style={{ width: "11%", textAlign: "right" }}>Monto</th>
                        <th style={{ width: "14%" }}>Fecha</th>
                        <th style={{ width: "12%" }}>Estado</th>
                        <th style={{ width: "10%" }}>Acciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      {inversionActivos.length === 0 && !nuevaLinea && (
                        <tr>
                          <td colSpan={7} style={{ textAlign: "center", color: "#999", padding: 30 }}>
                            Sin inversiones registradas para este edificio
                          </td>
                        </tr>
                      )}
                      {inversionActivos.map((a) =>
                        editandoLinea?.id === a.id ? (
                          <tr key={a.id} style={{ background: "#e8f4fd" }}>
                            <td>
                              <select
                                className="form-select form-select-sm"
                                value={editandoLinea.tipo_activo || ""}
                                onChange={(e) => setEditandoLinea((p) => ({ ...p, tipo_activo: e.target.value }))}
                              >
                                <option value="">Tipo...</option>
                                {TIPOS_ACTIVO_INVERSION.map((t) => (
                                  <option key={t} value={t}>
                                    {t}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <td>
                              <select
                                className="form-select form-select-sm"
                                value={editandoLinea.proveedor_id || ""}
                                onChange={(e) =>
                                  setEditandoLinea((p) => ({
                                    ...p,
                                    proveedor_id: e.target.value ? parseInt(e.target.value, 10) : null,
                                  }))
                                }
                              >
                                <option value="">Proveedor...</option>
                                {inversionProveedores.map((p) => (
                                  <option key={p.id} value={p.id}>
                                    {p.nombre}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <td>
                              <select
                                className="form-select form-select-sm"
                                value={editandoLinea.moneda || "CLP"}
                                onChange={(e) => setEditandoLinea((p) => ({ ...p, moneda: e.target.value }))}
                                style={{ paddingRight: 22 }}
                              >
                                <option value="CLP">CLP</option>
                                <option value="USD">USD</option>
                                <option value="UF">UF</option>
                              </select>
                            </td>
                            <td>
                              <input
                                className="form-control form-control-sm"
                                type="text"
                                inputMode="numeric"
                                placeholder="Monto"
                                value={formatMontoInput(editandoLinea.costo_unitario)}
                                onChange={(e) =>
                                  setEditandoLinea((p) => ({ ...p, costo_unitario: parseMontoInput(e.target.value) }))
                                }
                                style={{ textAlign: "right" }}
                              />
                            </td>
                            <td>
                              <input
                                className="form-control form-control-sm"
                                type="date"
                                value={editandoLinea.fecha || ""}
                                onChange={(e) => setEditandoLinea((p) => ({ ...p, fecha: e.target.value }))}
                              />
                            </td>
                            <td>
                              <select
                                className="form-select form-select-sm"
                                value={editandoLinea.estado || "activo"}
                                onChange={(e) => setEditandoLinea((p) => ({ ...p, estado: e.target.value }))}
                              >
                                <option value="activo">Ejecutado</option>
                                <option value="planificado">Planificado</option>
                              </select>
                            </td>
                            <td style={{ whiteSpace: "nowrap" }}>
                              <div style={{ display: "flex", gap: 4, justifyContent: "center" }}>
                                <button
                                  className="btn btn-success btn-sm"
                                  style={{ fontSize: "10px" }}
                                  title="Guardar cambios"
                                  onClick={handleGuardarEdicion}
                                >
                                  ✓
                                </button>
                                <button
                                  className="btn btn-secondary btn-sm"
                                  style={{ fontSize: "10px" }}
                                  title="Cancelar"
                                  onClick={() => setEditandoLinea(null)}
                                >
                                  ×
                                </button>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          <tr key={a.id} style={{ background: a.estado === "planificado" ? "#fff9e6" : "#f0fff0" }}>
                            <td>{getTipoActivoLabel(a.tipo_activo)}</td>
                            <td>
                              {a.proveedor?.nombre ||
                                inversionProveedores.find((p) => p.id === a.proveedor_id)?.nombre ||
                                "—"}
                            </td>
                            <td>{a.moneda}</td>
                            <td style={{ textAlign: "right" }}>{formatAmount(Number(a.costo_unitario), a.moneda)}</td>
                            <td>{a.fecha_planificada || a.fecha_compra || "—"}</td>
                            <td>
                              <span
                                style={{
                                  fontSize: "0.7rem",
                                  padding: "2px 6px",
                                  borderRadius: 3,
                                  background: a.estado === "planificado" ? "#fff3cd" : "#d4edda",
                                  color: a.estado === "planificado" ? "#856404" : "#155724",
                                }}
                              >
                                {a.estado === "planificado" ? "Planificado" : "Ejecutado"}
                              </span>
                            </td>
                            <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                              <div style={{ display: "flex", gap: 4, justifyContent: "center" }}>
                                <button
                                  className="btn btn-outline-primary btn-sm"
                                  style={{ fontSize: "10px", padding: "1px 6px" }}
                                  title="Editar línea"
                                  onClick={() => handleEditarLinea(a)}
                                >
                                  ✎
                                </button>
                                {a.estado === "planificado" && (
                                  <button
                                    className="btn btn-outline-success btn-sm"
                                    style={{ fontSize: "10px", padding: "1px 6px" }}
                                    title="Marcar como ejecutado (instalado)"
                                    onClick={() => handleEjecutarLinea(a.id)}
                                  >
                                    ✓
                                  </button>
                                )}
                                <button
                                  className="btn btn-outline-danger btn-sm"
                                  style={{ fontSize: "10px", padding: "1px 6px" }}
                                  title="Borrar línea"
                                  onClick={() => handleEliminarLinea(a.id)}
                                >
                                  ×
                                </button>
                              </div>
                            </td>
                          </tr>
                        )
                      )}

                      {nuevaLinea && (
                        <tr style={{ background: "#e8f4fd" }}>
                          <td>
                            <select
                              className="form-select form-select-sm"
                              value={nuevaLinea.tipo_activo || ""}
                              onChange={(e) => setNuevaLinea((p) => ({ ...p, tipo_activo: e.target.value }))}
                            >
                              <option value="">Tipo...</option>
                              {TIPOS_ACTIVO_INVERSION.map((t) => (
                                <option key={t} value={t}>
                                  {t}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td>
                            <select
                              className="form-select form-select-sm"
                              value={nuevaLinea.proveedor_id || ""}
                              onChange={(e) =>
                                setNuevaLinea((p) => ({
                                  ...p,
                                  proveedor_id: e.target.value ? parseInt(e.target.value, 10) : null,
                                }))
                              }
                            >
                              <option value="">Proveedor...</option>
                              {inversionProveedores.map((p) => (
                                <option key={p.id} value={p.id}>
                                  {p.nombre}
                                </option>
                              ))}
                            </select>
                          </td>
                          <td>
                            <select
                              className="form-select form-select-sm"
                              value={nuevaLinea.moneda || "CLP"}
                              onChange={(e) => setNuevaLinea((p) => ({ ...p, moneda: e.target.value }))}
                              style={{ paddingRight: 22 }}
                            >
                              <option value="CLP">CLP</option>
                              <option value="USD">USD</option>
                              <option value="UF">UF</option>
                            </select>
                          </td>
                          <td>
                            <input
                              className="form-control form-control-sm"
                              type="text"
                              inputMode="numeric"
                              placeholder="Monto"
                              value={formatMontoInput(nuevaLinea.costo_unitario)}
                              onChange={(e) =>
                                setNuevaLinea((p) => ({ ...p, costo_unitario: parseMontoInput(e.target.value) }))
                              }
                              style={{ textAlign: "right" }}
                            />
                          </td>
                          <td>
                            <input
                              className="form-control form-control-sm"
                              type="date"
                              value={nuevaLinea.fecha_planificada || ""}
                              onChange={(e) => setNuevaLinea((p) => ({ ...p, fecha_planificada: e.target.value }))}
                            />
                          </td>
                          <td>
                            <select
                              className="form-select form-select-sm"
                              value={nuevaLinea.estado || "activo"}
                              onChange={(e) => setNuevaLinea((p) => ({ ...p, estado: e.target.value }))}
                            >
                              <option value="activo">Ejecutado</option>
                              <option value="planificado">Planificado</option>
                            </select>
                          </td>
                          <td style={{ whiteSpace: "nowrap" }}>
                            <div style={{ display: "flex", gap: 4, justifyContent: "center" }}>
                              <button
                                className="btn btn-success btn-sm"
                                style={{ fontSize: "10px" }}
                                onClick={handleGuardarLinea}
                              >
                                ✓
                              </button>
                              <button
                                className="btn btn-secondary btn-sm"
                                style={{ fontSize: "10px" }}
                                onClick={() => setNuevaLinea(null)}
                              >
                                ×
                              </button>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  {inversionActivos.length > 0 &&
                    (() => {
                      const totalPlanCLP = inversionActivos
                        .filter((a) => a.estado === "planificado" && a.moneda !== "USD")
                        .reduce((s, a) => s + Number(a.costo_unitario), 0);
                      const totalPlanUSD = inversionActivos
                        .filter((a) => a.estado === "planificado" && a.moneda === "USD")
                        .reduce((s, a) => s + Number(a.costo_unitario), 0);
                      const totalEjeCLP = inversionActivos
                        .filter((a) => a.estado !== "planificado" && a.moneda !== "USD")
                        .reduce((s, a) => s + Number(a.costo_unitario), 0);
                      return (
                        <div style={{ textAlign: "right", fontSize: "0.85rem", marginTop: 8 }}>
                          <strong>Planificado: </strong>
                          {totalPlanCLP.toLocaleString("es-CL")} CLP
                          {totalPlanUSD > 0 && ` + US$ ${totalPlanUSD.toLocaleString("es-CL")}`}
                          {" | "}
                          <strong>Ejecutado: </strong>
                          {totalEjeCLP.toLocaleString("es-CL")} CLP
                        </div>
                      );
                    })()}
                </div>
              )}
            </>
          )}
        </Modal.Body>
      </Modal>

      {/* Chart Modal - Crecimiento Red */}
      <EdificiosChartModal open={showChartModal} onClose={() => setShowChartModal(false)} edificios={edificios} />

      {/* Modal de ficha técnica — puerta única (Bloque C), gateado a [1,4].
          modo dinámico: edificioModalData con datos → editar; null → crear (ficha vacía). */}
      <Modal show={showEdificioModal} onHide={() => setShowEdificioModal(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>
            {edificioModalData ? `Editar edificio — ${edificioModalData?.edificio?.toUpperCase()}` : "Nuevo edificio"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showEdificioModal && (
            <EdificioForm
              key={edificioModalData?.id ?? "nuevo"}
              modo={edificioModalData ? "editar" : "crear"}
              edificio={edificioModalData}
              pais={pais}
              proveedores={edificioModalProveedores}
              onSubmit={handleSaveEdificioModal}
              onCancel={() => setShowEdificioModal(false)}
            />
          )}
          {edificioModalSaving && <div className="text-muted mt-2">Guardando…</div>}
        </Modal.Body>
      </Modal>

      {/* Modal de comisión de edificio (Bloque C Fase 4), gateado a [1,4].
          key por id → remonta limpio y precarga los tramos del edificio elegido. */}
      {showComisionModal && comisionModalEdificio && (
        <EdificioComisionModal
          key={comisionModalEdificio.id}
          show={showComisionModal}
          edificio={comisionModalEdificio}
          saving={comisionModalSaving}
          onClose={() => setShowComisionModal(false)}
          onSubmit={handleSaveComisionModal}
        />
      )}
    </div>
  );
};

export default EdificiosTable;
